import { useEffect } from 'react';
import { create } from 'zustand';
import type { ToastPosition } from 'react-hot-toast';

/** Where App's Toaster puts toasts unless the open screen asks for another place. */
export const DEFAULT_TOAST_POSITION: ToastPosition = 'bottom-right';

type ToastPlacementState = {
  position: ToastPosition;
  setPosition: (position: ToastPosition) => void;
};

export const useToastPlacement = create<ToastPlacementState>((set) => ({
  position: DEFAULT_TOAST_POSITION,
  setPosition: (position) => set({ position }),
}));

/**
 * Toasts show at `position` while the calling screen is open, and at the
 * default again once it closes. For a screen whose main button sits where
 * toasts usually land, so a toast never covers it (the Launch page).
 */
export function useToastPositionWhileOpen(position: ToastPosition): void {
  useEffect(() => {
    const { setPosition } = useToastPlacement.getState();
    setPosition(position);
    return () => setPosition(DEFAULT_TOAST_POSITION);
  }, [position]);
}
